import React from "react"
// import "../style/style.css"

const Kontakt = (props) => (
  <div
    style={{ backgroundColor: "#F0EAE3", marginBottom: "-65px" }}
    className="preise-termine kontakt-float"
  >
    <div className="termine">
      <h1 className="preise-termine-headline">{props.title}</h1>
      <table>
        <tbody className="kontakt-text" style={{ width: "100%" }}>
          <tr className="kontakt-tel">
            <th className="kontakt-icon">📞</th>
            <td className="kontakt-inhalt">
              <div>{props.tel}</div>
              <div className="font-normal">{props.oeffnungszeiten}</div>
            </td>
          </tr>
          <tr className="kontakt-email">
            <th className="kontakt-icon">✉️</th>
            <td
              className="kontakt-inhalt"
              style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}
            >
              <div>{props.email}</div>
            </td>
          </tr>
        </tbody>
      </table>
      <div className="kontakt-standort">
        <div
          colSpan="2"
          className="kontakt-icon kontakt-standort-beschreibung kontakt-inhalt"
          dangerouslySetInnerHTML={{
            __html: props.text,
          }}
        ></div>
      </div>
    </div>
  </div>
)

export default Kontakt
